<div class="h-100 w-100 bc-mono-white b-logo overflow-hidden" fxLayout="column">
    <div fxLayout="column"
         fxLayoutAlign="center center"
         class="h-100 w-100">
        <div fxLayout="column" fxLayoutAlign="center center"
             class="w-100 pl-56 pr-56 pt-48 pb-36 main-shadow radius-16 w-514">
            <div class="h2-semi-bold text-center w-100">{{ 'i18n_af_loginTitle' | translate }}</div>
            @if (form) {
                <form [formGroup]="form" (submit)="login()" fxLayout="column" class="mt-32 w-385"
                      autocomplete="off">
                    <div fxLayout="column" fxFlex>
                        <div class="t2 c-primary-gray-600">{{ 'i18n_af_login' | translate }}</div>
                        <mat-form-field>
                            <input matInput
                                   formControlName="login"
                                   name="login"/>
                            @if (form.controls.login.hasError('required')) {
                                <mat-error
                                    class="t3 c-secondary-red-800">{{ 'i18n_af_commonErrorRequired' | translate }}
                                </mat-error>
                            }
                        </mat-form-field>
                        <div class="mt-32 t2 c-primary-gray-600">{{ 'i18n_af_password' | translate }}</div>
                        <mat-form-field>
                            <input matInput
                                   formControlName="password"
                                   name="password"
                                   [type]="showPassword ? 'text' : 'password'"/>
                            <ui-kit-svg matRipple
                                        matSuffix
                                        class="i-24 circle pointer p-8 c-primary-green-900"
                                        [name]="showPassword ? 'ic_eye_show' : 'ic_eye_hide'"
                                        (click)="showPassword=!showPassword">
                            </ui-kit-svg>
                            @if (form.controls.login.hasError('required')) {
                                <mat-error
                                    class="t3 c-secondary-red-800">{{ 'i18n_af_commonErrorRequired' | translate }}
                                </mat-error>
                            }
                        </mat-form-field>
                    </div>
                    @if (form.hasError('wrongCredentials')) {
                        <div class="t3 c-secondary-red-900">{{ 'i18n_af_errorWrongCredentials' | translate }}</div>
                    }
                    @if (notice) {
                        <af-support-notice class="w-100 mt-8"
                                           [accentText]="notice.accentKey"
                                           [warningText]="notice.textKey"/>
                    }
                    <div class="mt-40" fxLayout="row" fxLayoutAlign="center center" ngClass.mobile="w-100">
                        <ui-kit-button
                            [disabled]="form.invalid"
                            type="primary"
                            spinnerId="submit"
                            ngClass.mobile="w-100"
                            label="{{ 'i18n_af_buttonSignIn' | translate}}">
                        </ui-kit-button>
                    </div>
                    <ui-kit-button class="mt-16"
                                   type="text"
                                   buttonType="button"
                                   label="{{ 'i18n_af_buttonForgotPassword' | translate }}"
                                   (clickListener)="goToRecovery()">
                    </ui-kit-button>
                </form>
            }
        </div>
    </div>
</div>
